export default "__VITE_ASSET__4y25Fi2H__"